// CART DISABLED FOR EMPLOYEE TRAINING
// import axios from "axios";
// import router from "@/router";

// CART DISABLED FOR EMPLOYEE TRAINING
// const getCart = async (context) => {
//     await context.commit('setCart', null)
//     const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/carts/v1/active/cart/`, {
//         headers: {
//             'Authorization': `Bearer ${localStorage.getItem('access')}`
//         }
//     })).data
//     if (response.success) {
//         await context.commit('setCart', response)
//     } else {
//         await context.commit('setError', response.code)
//     }
// };
// const addCart = async (context, obj) => {
//     await context.commit('setCart', null)
//     const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/carts/v1/add/to/cart/`, obj, {
//         headers: {
//             'Authorization': `Bearer ${localStorage.getItem('access')}`
//         }
//     })).data
//     if (response.success) {
//         await context.commit('setNotification', response.code)
//         await context.commit('setCart', response)
//     } else {
//         await context.commit('setError', response.code)
//     }
// };
// const removeCart = async (context, obj) => {
//     const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/carts/v1/remove/unpaid/course/`, obj, {
//         headers: {
//             'Authorization': `Bearer ${localStorage.getItem('access')}`
//         }
//     })).data
//     if (response.success) {
//         await context.commit('setNotification', response.code)
//     } else {
//         await context.commit('setError', response.code)
//     }
// };
// const getCheckout = async (context) => {
//     await context.commit('setCheckout', null)
//     const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/orders/v1/order-checkout/`, {
//         headers: {
//             'Authorization': `Bearer ${localStorage.getItem('access')}`
//         }
//     })).data
//     if (response.success) {
//         await context.commit('setCheckout', response)
//     } else {
//         await context.commit('setError', response.code)
//     }
// };

// const paymentTransaction = async (context, obj) => {
//     const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/orders/v1/receipt-pay/`, obj, {
//         headers: {
//             'Authorization': `Bearer ${localStorage.getItem('access')}`
//         }
//     })).data
//     if (response.success) {
//         await context.commit('setNotification', response.code)
//     } else {
//         await context.commit('setError', response.code)
//     }
// };
// const paymentTransactionPayme = async (context, obj) => {
//     const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/orders/v1/merchant-pay/`, obj, {
//         headers: {
//             'Authorization': `Bearer ${localStorage.getItem('access')}`
//         }
//     })).data
//     if (response.success) {
//         window.location.replace(response.url);
//     } else {
//         await context.commit('setError', response.code)
//     }
// };
// const paymentTransactionWallet = async (context, obj) => {
//     const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/orders/v1/wallet-pay/`, obj, {
//         headers: {
//             'Authorization': `Bearer ${localStorage.getItem('access')}`
//         }
//     })).data
//     if (response.success) {
//         await context.commit('setNotification', response.code)
//         await router.push('/cart')
//     } else {
//         await context.commit('setError', response.code)
//     }
// };

export default {
  // CART DISABLED - All actions commented out
  // getCart,
  // addCart,
  // removeCart,
  // getCheckout,
  // paymentTransaction,
  // paymentTransactionPayme,
  // paymentTransactionWallet,
};
